import { useCallback } from 'react'

import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getTestRetryTrigger } from 'services/Store/Project/triggers'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const RestartButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  styles,
  mode,
  font,
  children,
}) => {
  const trigger = useProjectContext(getTestRetryTrigger)
  const dispatch = useProjectDispatch()
  const label = element?.value?.label

  const onClick = useCallback(() => dispatch(trigger.actionCreator()), [dispatch, trigger])

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={trigger.disabled}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default RestartButtonElement
